import { BaseApi } from "../base";

export default class SpamApi extends BaseApi {
  protected readonly prefix = "";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchTrusted = () => this.get("trustedEmails");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBlocked = () => this.get("blockedEmails");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeBlocked = (id: string) => this.delete(`blockedEmails/${id}`);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeTrusted = (id: string) => this.delete(`trustedEmails/${id}`);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addTrusted = (entry: string) => this.post("trustedEmails", { email: entry });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addBlocked = (entry: string) => this.post("blockedEmails", { email: entry });
}
